import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import About from "@/components/site/About";
import Experience from "@/components/site/Experience";
import Skills from "@/components/site/Skills";
import Volunteering from "@/components/site/Volunteering";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import ChatWidget from "@/components/site/ChatWidget";
import { useRef, useState } from "react";

export default function Home() {
  const [chatOpen, setChatOpen] = useState(false);
  const [initialPrompt, setInitialPrompt] = useState("");
  const chatRef = useRef(null);

  const openChatWith = (prompt = "") => {
    setInitialPrompt(prompt);
    setChatOpen(true);
  };

  return (
    <main className="relative">
      <Nav onOpenChat={() => openChatWith("")} />
      <Hero onAsk={openChatWith} />
      <Marquee />
      <About />
      <Experience />
      <Skills />
      <Volunteering />
      <Contact />
      <Footer />
      <ChatWidget
        ref={chatRef}
        open={chatOpen}
        onOpenChange={setChatOpen}
        initialPrompt={initialPrompt}
        onPromptConsumed={() => setInitialPrompt("")}
      />
    </main>
  );
}
